import { useEffect } from 'react';

export const useCustomEvent = ({ eventName, onSignal, element = window, options = {} }) => {
    const handleSignal = onSignal || (() => null);

    useEffect(() => {
        if (typeof handleSignal === 'function') {
            element.addEventListener(eventName, handleSignal, options);

            return () => element.removeEventListener(eventName, handleSignal, options);
        }
    }, [element, eventName, handleSignal, options]);

    const callEvent = (data) => {
        const event = new CustomEvent(eventName, { detail: data });

        element.dispatchEvent(event);
    };

    return callEvent;
};
